"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/card.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.card
 * @name rinca.apps.card
 * @packageName rinca.apps
 * @description A module that includes the card component.
 */
angular.module('rinca.apps.card', ['ui.router'])
    .controller('CardController', controllers_1.CardController)
    .controller('CardMobileController', controllers_1.CardMobileController)
    .service('_card', services_1.CardService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/index.js
// module id = 453
// module chunks = 0